<div class="top-menu-wrapper lato">
    <div *ngIf="!isLogin else logged" class="desktop-top-menu" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" style="padding-left: 16px;min-width: 200px;">
            <ng-container *ngIf="isBannerExist">
                <button  appToggBtn (click)="toggleBanner()"></button>
                <p i18n style="padding-left: 8px;">Hide Promotions</p>
            </ng-container>
            <ng-container *ngIf="!isBannerExist">
                <span style="width: 132px;"></span>
            </ng-container>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center"  fxLayoutGap="24px" class="top-menu-wrapper_links">
            <a [routerLink]="providerTrx" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"><img src="{{licenceService.getKey('operator-icon')}}" alt="inline-logo" /><span i18n>Providers</span></a>
            <!-- <a [routerLink]="arcadeUrl" routerLinkActive="active" i18n>Arcade</a> -->
            <a [routerLink]="plinkoUrl" routerLinkActive="active" ><img src="{{licenceService.getKey('icon-easywin-luckera')}}" alt="inline-logo" /><span>Easy Win</span></a>
            <a [routerLink]="liveCasinoUrl" routerLinkActive="active" ><img src="{{licenceService.getKey('icon-live-casino-luckera')}}" alt="inline-logo" /><span i18n>Live Casino</span></a>
            <!-- <a [routerLink]="promotionsTrx" routerLinkActive="active" i18n>Promotions</a> -->
            <!-- <a [topDrawerRouterLink]="[lostPasswordTrx]" i18n>lost password</a> -->
        </div>
        <span style="width: 200px;"></span>
    </div>
</div>
<ng-template #logged>
    <div class="desktop-top-menu lato" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" style="padding-left: 20px;min-width: 200px;">
            <ng-container *ngIf="isBannerExist">
                <button  appToggBtn (click)="toggleBanner()"></button>
                <p i18n style="padding-left: 8px;">Hide Promotions</p>
            </ng-container>
            <ng-container *ngIf="!isBannerExist">
                <span style="width: 132px;"></span>
            </ng-container>
        </div>
         <div fxLayout="row" fxLayoutAlign="space-evenly center"  fxLayoutGap="24px" class="top-menu-wrapper_links">
            <a [routerLink]="providerTrx" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"><img src="{{licenceService.getKey('operator-icon')}}" alt="inline-logo" /><span i18n>Providers</span></a>
            <!-- <a [routerLink]="arcadeUrl" routerLinkActive="active" i18n>Arcade</a> -->
            <a [routerLink]="plinkoUrl" routerLinkActive="active" ><img src="{{licenceService.getKey('icon-easywin-luckera')}}" alt="inline-logo" /><span>Easy Win</span></a>
            <a [routerLink]="liveCasinoUrl" routerLinkActive="active" ><img src="{{licenceService.getKey('icon-live-casino-luckera')}}" alt="inline-logo" /><span i18n>Live Casino</span></a>
            <!-- <a [routerLink]="promotionsTrx" routerLinkActive="active" i18n>Promotions</a> -->
            <!-- <a [topDrawerRouterLink]="[lostPasswordTrx]" i18n>lost password</a> -->
        </div>
        <span style="width: 200px;"></span>
    </div>
</ng-template>